@import (reference) '../../../../constants/spacing.module.less';

.configure-shipment-form {
  display: flex;
  flex-flow: row wrap;
  gap: @space-8;
  padding: @space-0 @space-16 @space-8;
}
